import {useSelector} from "react-redux";
import {Navigate} from "react-router";
import {NOT_FOUND_ERROR_PAGE_ROUTE} from "../../constants/routerConstants";
import {isRoutePermitted} from "../others/routerHelpers";

const OnlyForSomeRolesRoute = ({ children, roles = [] }) => {
  const { user } = useSelector((state) => state.auth.login);
  const isPermitted = isRoutePermitted(user.roles, roles);
  return isPermitted ? (
    children
  ) : (
    <Navigate to={NOT_FOUND_ERROR_PAGE_ROUTE} replace />
  );
};

export default OnlyForSomeRolesRoute;
